import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AiSupportChatRequest, AiSupportChatResponse } from "@models/ai-support.model";

@Injectable({
    providedIn: "root",
})
export class AiSupportChatService {
    private readonly endpoint = `${environment.apiUrlBasePath}/ai-support/chat`;

    constructor(private http: HttpClient) {}

    public sendMessage(payload: AiSupportChatRequest): Observable<AiSupportChatResponse> {
        return this.http.post<AiSupportChatResponse>(this.endpoint, payload);
    }
}
